import { resetPassword } from '@app/api/user.api';
import { BaseButton } from '@app/components/common/BaseButton/BaseButton';
import { BaseCard } from '@app/components/common/BaseCard/BaseCard';
import { BaseForm } from '@app/components/common/forms/BaseForm/BaseForm';
import { notificationController } from '@app/controllers/notificationController';
import { authUserService } from '@app/services/authUser.service';
import { Col, Form, Input, Row, Space } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import React, { useState } from 'react';

type ResetPasswordType = Record<string, unknown>;

const ResetPassword: React.FC<ResetPasswordType> = () => {
  const [hideForm, setHideForm] = useState<boolean>(true);
  const [passwordForm] = useForm();

  function onFinish(values: any): void {
    const user = authUserService.getUser();
    resetPassword(user?.id ?? 0, values)
      .then((response) => {
        notificationController.success({ message: 'Password reset successful!' });
        setHideForm(true);
      })
      .catch((error) => {
        notificationController.error({ message: error.message });
      });
    passwordForm.resetFields();
  }

  const onCancel = () => {
    setHideForm(true);
  };

  return (
    <BaseCard title="Reset Password">
      <Row>
        <Col span={24}>
          {hideForm ? (
            <BaseButton htmlType="button" type="link" size="middle" onClick={() => setHideForm(false)}>
              Forgot Password? Click here to reset your password
            </BaseButton>
          ) : (
            <Form
              form={passwordForm}
              onFinish={onFinish}
              labelCol={{ lg: { span: 6 }, md: { span: 6 }, sm: { span: 24 } }}
              labelAlign="left"
              labelWrap
              wrapperCol={{ lg: { span: 16 }, md: { span: 18 }, sm: { span: 24 } }}
              size="small"
            >
              <Row>
                <Col lg={12} sm={24} xl={8}>
                  <BaseForm.Item name="new_password" label="New Password" rules={[{ required: true }]}>
                    <Input.Password />
                  </BaseForm.Item>
                  <BaseForm.Item name="new_password_confirmation" label="Confirm Password" rules={[{ required: true }]}>
                    <Input.Password />
                  </BaseForm.Item>
                </Col>
              </Row>

              <Space>
                <BaseButton htmlType="submit" type="primary" size="middle">
                  Save
                </BaseButton>
                <BaseButton htmlType="button" type="primary" size="middle" onClick={onCancel}>
                  Cancel
                </BaseButton>
              </Space>
            </Form>
          )}
        </Col>
      </Row>
    </BaseCard>
  );
};

export default ResetPassword;
